import { Action } from "@reduxjs/toolkit";
import { DashboardState } from "./types";
import { isType } from "typescript-fsa";
import { dashboardActions } from "./actions";

const initialState: DashboardState = {
    data: null,
}

export function DashboardReducer(state = initialState, action: Action): DashboardState {
    if (isType(action, dashboardActions.fetchDashboardData.done)) {
        return {
            ...state,
            data: {
                total_properties: action.payload.result.total_properties,
                total_rent_properties: action.payload.result.total_rent_properties,
                total_sale_properties: action.payload.result.total_sale_properties,
                total_owners: action.payload.result.total_owners,
            }
        }
    }

    if (isType(action, dashboardActions.resetToInitialState)) {
        return initialState;
    }

    return state;
}